<template>
  <div>
    <div class="row">
      <div class="flex xs10 offset--xs1">
        <va-card :title="title">
          <div class="row">
            <div class='flex md12 sm6 xs12' v-if="showId">
              <va-input
                v-model='questionId'
                label='questionId'
                disabled
              />
            </div>
            <!-- 公司名 -->
            <div class="flex md12 sm6 xs12">
              <va-input
                v-model="insertData.company"
                label="公司名"
                placeholder="请输入公司名"
                :maxlength="256"
              />
            </div>
            <div class="flex md6 sm6 xs6">
              <va-select
                v-model="insertData.position"
                label="岗位"
                textBy="TEXT"
                valueBy="CODE"
                :options="positions"
                searchable
                width="350px"
              />
            </div>
            <div class="flex md6 sm6 xs6">
              <va-select
                label="题目类别"
                v-model="insertData.category"
                :options="categories"
                searchable
                textBy="TEXT"
                valueBy="CODE"
              />
            </div>
            <div class="flex md6 sm6 xs6">
              <va-select
                label="题目子类别"
                v-model="insertData.subCategory"
                :options="subCategories"
                searchable
                textBy="TEXT"
                valueBy="CODE"
              />
            </div>
            <div class="flex md6 sm6 xs6">
              <va-select
                label="难度"
                v-model="insertData.difficulty"
                :options="difficulties"
                textBy="TEXT"
                valueBy="CODE"
              />
            </div>
            <!-- 标题 -->
            <div class="flex md12 sm6 xs12">
              <va-input
                v-model="insertData.title"
                label="标题"
                placeholder="请输入标题"
                :maxlength="256"
                @input="updateCharCount('title')"
              />
              <small>已输入 {{ charCount.title || 0 }}/256 字符</small>
            </div>

            <!-- 题目正文 -->
            <div class="flex md12 sm6 xs12">
              <va-button flat small>题目正文</va-button>

              <template v-if="!questionId || insertData.source === 0">
                <!-- 富文本编辑器 -->
                <vue-trix
                  v-model="insertData.problemDescription"
                  placeholder="题目正文"
                  :config="captionConfig"
                  @trix-attachment-add="handleAttachmentChanges"
                  @input="updateCharCount('problemDescription')"
                />
              </template>

              <template v-else-if="insertData.source === 1">
                <!-- 普通输入框 -->
                <va-input v-model="insertData.problemDescription" />

                <!-- 题目正文展示 -->
                <va-button flat small>题目正文展示</va-button>
                <div v-html="insertData.problemDescription"></div>
              </template>

              <small>已输入 {{ charCount.problemDescription || 0 }}/1048576 字符</small>
            </div>

            <!-- 题目解释 -->
            <div class="flex md12 sm6 xs12">
              <va-button flat small>题目解释</va-button>

              <template v-if="!questionId || insertData.source === 0">
                <!-- 富文本编辑器 -->
                <vue-trix
                  v-model="insertData.explanation"
                  placeholder="题目解释"
                  :config="captionConfig"
                  @trix-attachment-add="handleAttachmentChanges"
                  @input="updateCharCount('explanation')"
                />
              </template>

              <template v-else-if="insertData.source === 1">
                <!-- 普通输入框 -->
                <va-input v-model="insertData.explanation" />

                <!-- 题目解释展示 -->
                <va-button flat small>题目解释展示</va-button>
                <div v-html="insertData.explanation"></div>
              </template>

              <small>已输入 {{ charCount.explanation || 0 }}/65535  字符</small>
            </div>

            <!-- 解题提示 -->
            <div class="flex md12 sm6 xs12">
              <va-button flat small>解题提示</va-button>
              <va-input
                v-model="insertData.hits"
                placeholder="解题提示"
                type="textarea"
                :autosize="true"
                :maxlength="2048"
                @input="updateCharCount('hits')"
              />
              <small>已输入 {{ charCount.hits || 0 }}/65535 字符</small>
            </div>

            <!-- 空间和时间复杂度 -->
            <div class="flex md12 sm6 xs12">
              <va-button flat small>空间和时间复杂度</va-button>
              <va-input
                v-model="insertData.spaceTimeComplexity"
                placeholder="空间和时间复杂度"
                type="textarea"
                :autosize="true"
                :maxlength="512"
                @input="updateCharCount('spaceTimeComplexity')"
              />
              <small>已输入 {{ charCount.spaceTimeComplexity || 0 }}/512 字符</small>
            </div>

            <!-- 示例输入 -->
            <div class="flex md12 sm6 xs12">
              <va-button flat small>示例输入</va-button>

              <template v-if="!questionId || insertData.source === 0">
                <vue-trix
                  v-model="insertData.sampleInput"
                  placeholder="示例输入"
                  :config="captionConfig"
                  @trix-attachment-add="handleAttachmentChanges"
                  @input="updateCharCount('sampleInput')"
                />
              </template>

              <template v-else-if="insertData.source === 1">
                <va-input v-model="insertData.sampleInput" />
                <va-button flat small>示例输入展示</va-button>
                <div v-html="insertData.sampleInput"></div>
              </template>

              <small>已输入 {{ charCount.sampleInput || 0 }}/65535 字符</small>
            </div>

            <!-- 示例输出 -->
            <div class="flex md12 sm6 xs12">
              <va-button flat small>示例输出</va-button>

              <template v-if="!questionId || insertData.source === 0">
                <vue-trix
                  v-model="insertData.sampleOutput"
                  placeholder="示例输出"
                  :config="captionConfig"
                  @trix-attachment-add="handleAttachmentChanges"
                  @input="updateCharCount('sampleOutput')"
                />
              </template>

              <template v-else-if="insertData.source === 1">
                <va-input v-model="insertData.sampleOutput" />
                <va-button flat small>示例输出展示</va-button>
                <div v-html="insertData.sampleOutput"></div>
              </template>

              <small>已输入 {{ charCount.sampleOutput || 0 }}/65535 字符</small>
            </div>

            <!-- 答案 -->
            <div class="flex md12 sm6 xs12">
              <va-button flat small>答案</va-button>

              <template v-if="!questionId || insertData.source === 0">
                <vue-trix
                  v-model="insertData.solution"
                  placeholder="答案"
                  :config="captionConfig"
                  @trix-attachment-add="handleAttachmentChanges"
                  @input="updateCharCount('solution')"
                />
              </template>

              <template v-else-if="insertData.source === 1">
                <va-input v-model="insertData.solution" />
                <va-button flat small>答案展示</va-button>
                <div v-html="insertData.solution"></div>
              </template>

              <small>已输入 {{ charCount.solution || 0 }}/65535 字符</small>
            </div>

          </div>

          <div class='flex md2 offset--md5'>
            <va-button class="ma-0" color="primary" slot="trigger" @click="clickSubmit"  :disabled="!submitButtonStatus">
              submit
            </va-button>
          </div>

        </va-card>
      </div>
    </div>
  </div>

</template>

<script>

import 'vue-trix'
import questionApi from '@/api/question'
import {
  QUESTION_POSITION,
  QUESTION_CATEGORY,
  QUESTION_SUB_CATEGORY,
  QUESTION_DIFFICULTY,
} from '@/utils/constants'
import uploadApi from '@/api/upload'

export default {
  data () {
    return {
      questionId: null,
      title: '新增题目',
      showId: false,
      submitButtonStatus: true,
      positions: [],
      categories: [],
      subCategories: [],
      difficulties: [],
      insertData: {
        company: '',
        position: '',
        category: '',
        subCategory: '',
        difficulty: '',
        title: '',
        problemDescription: '',
        explanation: '',
        hits: '',
        spaceTimeComplexity: '',
        sampleInput: '',
        sampleOutput: '',
        solution: '',
        html_url: '',
        source: '',
      },
      // 统计用户输入的数据长度，包括隐藏的HTML字符
      charCount: {
        title: 0,
        problemDescription: 0,
        explanation: 0,
        hits: 0,
        spaceTimeComplexity: 0,
        sampleInput: 0,
        sampleOutput: 0,
        solution: 0,
      },
      captionConfig: {
        attachments: {
          preview: {
            caption: {
              name: false,
              size: false,
            },
          },
        },
      },
      error: {
        fields: [],
      },
    }
  },
  mounted () {
    this.initializeCharacterCount()
  },

  created () {
    // 初始化每个字段的字符计数
    for (const field in this.charCount) {
      if (this.insertData[field]) {
        this.charCount[field] = this.insertData[field].length
      }
    }
    const params = this.$route.params
    if (params.id) {
      this.questionId = params.id
      this.showId = true
      this.title = '编辑题目'
      this.loadQuestionDetails() // 加载已有题目数据
    }

    // 动态初始化下拉框选项
    this.positions = QUESTION_POSITION.map(item => item.CODE)
    this.categories = QUESTION_CATEGORY.map(item => item.CODE)
    this.subCategories = QUESTION_SUB_CATEGORY.map(item => item.CODE)
    this.difficulties = QUESTION_DIFFICULTY.map(item => item.CODE)
  },

  methods: {
    initializeCharacterCount () {
      for (const field in this.charCount) {
        if (this.insertData[field]) {
          this.charCount[field] = this.insertData[field].length
        } else {
          this.charCount[field] = 0
        }
      }
    },
    // 实时更新用户已输入的字符数
    updateCharCount (field) {
      if (this.insertData[field]) {
        this.charCount[field] = this.insertData[field].length
      } else {
        this.charCount[field] = 0
      }
    },
    // 加载题目详情
    loadQuestionDetails () {
      questionApi.getQuestion(this.questionId)
        .then((response) => {
          const question = response.question

          // 直接赋值 CODE 到 insertData
          this.insertData.position = question.position || ''
          this.insertData.category = question.category || ''
          this.insertData.subCategory = question.subCategory || ''
          this.insertData.difficulty = question.difficulty || ''

          // 普通文本字段直接赋值
          this.insertData.source = question.source
          this.insertData.hits = question.hits || ''
          this.insertData.spaceTimeComplexity = question.spaceTimeComplexity || ''
          this.insertData.title = question.title || ''
          this.insertData.company = question.company || ''

          this.insertData.problemDescription = question.problemDescription || ''
          this.insertData.explanation = question.explanation || ''
          this.insertData.sampleInput = question.sampleInput || ''
          this.insertData.sampleOutput = question.sampleOutput || ''
          this.insertData.solution = question.solution || ''
          this.insertData.html_url = question.html_url || ''
          // 数据加载完成后初始化字符统计
          this.initializeCharacterCount()
        })
        .catch((error) => {
          console.log('Error Response:', error)
          this.showToast(error.msg, { duration: 2000, icon: 'fa-warning' })
        })
    },

    // 提交数据
    clickSubmit () {
      // 数据长度校验
      if (!this.validateLength()) {
        return
      }
      if (!this.validateFields()) {
        return
      }

      const data = { ...this.insertData }

      data.createTime = Math.floor(Date.now() / 1000)
      data.updateTime = Math.floor(Date.now() / 1000)
      this.submitButtonStatus = false

      if (this.questionId) {
        questionApi
          .updateQuestion(this.questionId, data)
          .then(() => {
            this.showToast('题目更新成功', { duration: 1000, icon: 'fa-check' })
            this.$router.push({ name: 'listQuestion' })
          })
          .catch((error) => {
            console.error('Error in updateQuestion:', error) // 打印完整的错误对象
            this.showToast(error.msg, { duration: 1000, icon: 'fa-warning' })
          })
          .finally(() => {
            this.submitButtonStatus = true
          })
      } else {
        questionApi
          .createQuestion(data)
          .then(() => {
            this.showToast('题目创建成功', { duration: 1000, icon: 'fa-check' })
            this.$router.push({ name: 'listQuestion' })
          })
          .catch((error) => {
            this.showToast(error.msg, { duration: 1000, icon: 'fa-warning' })
          })
          .finally(() => {
            this.submitButtonStatus = true
          })
      }
    },
    // 上传附件
    handleAttachmentChanges (event) {
      const file = event.attachment.file
      const formData = new FormData()

      // 将文件添加到表单数据中
      formData.append('type', 'image') // 可以根据需要修改文件类型
      formData.append('file', file)

      // 调用上传接口
      uploadApi.uploadImage(formData)
        .then((response) => {
          // 将返回的 URL 设置为附件的属性
          event.attachment.setAttributes({ url: response.url })
          this.showToast('上传图片成功', { duration: 1000, icon: 'fa-check' })
        })
        .catch((error) => {
          console.error(error)
          this.showToast('上传失败，请重试', { duration: 1000, icon: 'fa-warning' })
        })
    },

    // // 格式化文本以保留换行和缩进
    // formatText (text) {
    //   return `<pre>${text}</pre>` // 使用 <pre> 保留缩进和换行
    // },

    // // 提交的时候去除HTML标签，保留换行符
    // stripHtml (html) {
    //   if (!html) return ''
    //   return html
    //     .replace(/<br\s*\/?>/g, '\n') // 替换 <br> 为换行符
    //     .replace(/<pre>/g, '') // 去掉 <pre>
    //     .replace(/<\/pre>/g, '') // 去掉 </pre>
    //     .replace(/<[^>]+>/g, '') // 去除其他HTML标签
    // },

    // 计算用户输入数据长度，不能超过数据库限制
    validateLength () {
      const fieldLimits = {
        title: 256, // 题目标题仍然有限制
        problemDescription: 1048576, // 虽然数据库是LONGTEXT，但是为了防止前端崩溃这里采用1MB作为限制
        explanation: 65535, // TEXT
        hits: 65535, // TEXT
        spaceTimeComplexity: 512,
        sampleInput: 65535, // TEXT
        sampleOutput: 65535, // TEXT
        solution: 65535, // TEXT
      }

      for (const field in fieldLimits) {
        if (
          this.insertData[field] &&
            this.insertData[field].length > fieldLimits[field]
        ) {
          this.showToast(
              `${field} 超过了最大长度限制 (${fieldLimits[field]} 个字符，包括HTML标签)`,
              { duration: 2000, icon: 'fa-warning' },
          )
          return false
        }
      }
      return true
    },

    // 验证表单必填项
    validateFields () {
      const requiredFields = [
        { key: 'position', label: '题目范围' },
        { key: 'category', label: '题目类别' },
        { key: 'difficulty', label: '难度' },
        { key: 'title', label: '标题' },
        { key: 'problemDescription', label: '题目正文' },
      ]

      // 只有当 position 不是 "product-management" 时才验证 subCategory
      if (this.insertData.position !== 'product-management') {
        requiredFields.push({ key: 'subCategory', label: '题目子类别' })
      }

      this.error.fields = requiredFields.filter((field) => {
        const value = this.insertData[field.key]
        return !value // 检查是否为空或 null
      })

      if (this.error.fields.length > 0) {
        this.showToast(
            `${this.error.fields.map((f) => f.label).join('、')} 是必填项`,
            { duration: 2000, icon: 'fa-warning' },
        )
        return false
      }
      return true
    },

  },
}

</script>

<style>
</style>
